import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class RecoveryStore {
    loader = false;
    token = null;
    errorMessage = null;
    code = null;
    success = false;
    phone = null;

    recoverPassword = phone => {
        this.loader = true;
        this.errorMessage = null;
        this.phone = phone;

        const data = { login: phone };

        Api.fetch('auth/recovery/init', data, 'POST')
            .then(data => {
                this.token = data.result.token;
            })
            .catch(data => (this.errorMessage = data.error_description))
            .finally(() => {
                this.loader = false;
            });
    };

    onChange = code => {
        this.errorMessage = null;
        this.code = code;

        if (code.length === 6) {
            this.sendCode();
        }
    };

    sendCode = () => {
        const data = {
            token: this.token,
            code: this.code,
            password: this.code,
        };

        Api.fetch('auth/recovery/finish', data, 'POST')
            .then(
                data => (this.success = true), // this.props.history.replace('/')
                // errorMessage: loc(LoginLoc.invalidCode),
            )
            .catch(data => (this.errorMessage = data.error_description));
    };
}

decorate(RecoveryStore, {
    loader: observable,
    token: observable,
    phone: observable,
    code: observable,
    success: observable,
    errorMessage: observable,

    recoverPassword: action,
    sendCode: action,
    onChange: action,
});
